import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { FormSnackBar, Card, CardContent, CardActions, Button, makeStyles, Grid, FormField, Avatar, ErrorHandling, InputFileUpload, Loader, } from "../../mui";
import { ContentTypography, getContent } from "../../common/content";
import defaults from "../../../utils/defaults";
import { FormFieldType, userRole, currency } from "../../../utils/enums";
import { EDIT_ORGANIZATION } from "../Queries";
import ColorModeContext from "../../../routes/ColorModeContext";
import constants from "../../../utils/constants";
export const ORGANIZATION = gql `
  query Organization($id: ID!) {
    organization(id: $id) {
      id
      name
      website
      industry
      currency
      linkedinUrl
      facebookUrl
      twitterUrl
      angelUrl
      crunchbaseUrl
      primaryTheme
      logo {
        id
        url
      }
    }
    currentUser {
      id
      role
    }
  }
`;
const useStyles = makeStyles((theme) => ({
    tabLabel: {
        fontWeight: "bold",
    },
    untransformBttn: {
        textTransform: "none",
    },
}));
const OrganizationProfile = ({}) => {
    const id = localStorage.getItem("organizationId") || null;
    const classes = useStyles();
    const colorMode = React.useContext(ColorModeContext);
    const [organization, setOrganization] = React.useState(defaults.organizations);
    const [actionsVisible, setActionsVisible] = React.useState(false);
    const [snackBar, setSnackBar] = React.useState({
        open: false,
        message: "",
        type: "",
    });
    const { loading, error, data } = useQuery(ORGANIZATION, {
        variables: { id },
    });
    const [editOrganization, { loading: editOrganizationLoading }] = useMutation(EDIT_ORGANIZATION, {
        refetchQueries: ["Organization"],
    });
    React.useEffect(() => {
        setOrganization(data?.organization || defaults.organizations);
    }, [data]);
    const handleOrganizationChange = (event) => {
        setActionsVisible(true);
        if (event?.target?.name === "uploadLogo") {
            setOrganization({
                ...organization,
                uploadLogo: event.target.files[0],
            });
        }
        else {
            setOrganization({
                ...organization,
                [event.target.name]: event.target.value,
            });
        }
        if (event?.target?.name === "primaryTheme") {
            colorMode.togglePrimaryTheme({
                color: event?.target?.value,
            });
        }
    };
    if (loading || editOrganizationLoading)
        return _jsx(Loader, { size: 60 });
    if (error)
        return _jsx(ErrorHandling, { error: error });
    const manageActionPermitted = [userRole.Admin, userRole.Staff].includes(data?.currentUser?.role);
    return (_jsxs(_Fragment, { children: [_jsx(FormSnackBar, { snackBar: snackBar, setSnackBar: setSnackBar }), _jsxs(Card, { children: [_jsx(CardContent, { children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Avatar, { alt: "avatar", src: organization?.logo?.url, sx: { width: 148, height: 148 } }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(InputFileUpload, { type: "file", name: "uploadLogo", onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 9, children: _jsx(FormField, { disabled: !manageActionPermitted, name: "name", fieldType: FormFieldType.TextField, value: organization?.name, label: getContent("nameLabel"), onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { disabled: !manageActionPermitted, name: "industry", fieldType: FormFieldType.TextField, value: organization?.industry, label: getContent("industryLabel"), onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { disabled: !manageActionPermitted, name: "website", fieldType: FormFieldType.Link, value: organization?.website, label: getContent("websiteLabel"), onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { name: "currency", fieldType: FormFieldType.SingleSelect, enumValues: Object.keys(currency), value: organization?.currency, label: getContent("platformCurrencyLabel"), onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { disabled: !manageActionPermitted, name: "linkedinUrl", fieldType: FormFieldType.TextField, value: organization?.linkedinUrl, label: getContent("linkedinLabel"), onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { disabled: !manageActionPermitted, name: "facebookUrl", fieldType: FormFieldType.TextField, value: organization?.facebookUrl, label: getContent("facebookLabel"), onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { disabled: !manageActionPermitted, name: "twitterUrl", fieldType: FormFieldType.TextField, value: organization?.twitterUrl, label: getContent("twitterLabel"), onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { disabled: !manageActionPermitted, name: "angelUrl", fieldType: FormFieldType.TextField, value: organization?.angelUrl, label: getContent("angelLabel"), onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { disabled: !manageActionPermitted, name: "crunchbaseUrl", fieldType: FormFieldType.TextField, value: organization?.crunchbaseUrl, label: getContent("crunchbaseLabel"), onChange: handleOrganizationChange }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(FormField, { disabled: !manageActionPermitted, name: "primaryTheme", fieldType: FormFieldType.Color, value: organization?.primaryTheme || constants.DEFAULT_PRIMARY_THEME, label: getContent("primaryThemeLabel"), onChange: handleOrganizationChange }) })] }) }), _jsx(CardActions, { children: manageActionPermitted && actionsVisible ? (_jsxs(Grid, { item: true, xs: 12, container: true, spacing: 2, justifyContent: "flex-end", alignItems: "flex-end", children: [_jsx(Grid, { item: true, children: _jsx(Button, { color: "primary", className: classes.untransformBttn, onClick: () => {
                                            const id = organization.id;
                                            const data = {
                                                name: organization?.name || "",
                                                website: organization?.website || "",
                                                industry: organization?.industry || "",
                                                currency: organization?.currency || currency.usd,
                                                linkedinUrl: organization?.linkedinUrl || "",
                                                facebookUrl: organization?.facebookUrl || "",
                                                twitterUrl: organization?.twitterUrl || "",
                                                angelUrl: organization?.angelUrl || "",
                                                crunchbaseUrl: organization?.crunchbaseUrl || "",
                                                primaryTheme: organization?.primaryTheme,
                                                uploadLogo: organization?.uploadLogo || null,
                                            };
                                            editOrganization({
                                                variables: {
                                                    id,
                                                    data,
                                                },
                                                onCompleted: () => setSnackBar({
                                                    open: true,
                                                    message: `Updated organization info successfully!`,
                                                    type: "success",
                                                }),
                                                onError: () => setSnackBar({
                                                    open: true,
                                                    message: `${getContent("errorMessage")}`,
                                                    type: "error",
                                                }),
                                            });
                                            setActionsVisible(false);
                                        }, children: _jsx(ContentTypography, { variant: "button", color: "primary", fontWeight: "bold", sx: { textTransform: "none" }, field: "saveChangesLabel" }) }) }), _jsx(Grid, { item: true, children: _jsx(Button, { color: "primary", className: classes.untransformBttn, onClick: () => {
                                            setOrganization(data?.organization);
                                            setActionsVisible(false);
                                        }, children: _jsx(ContentTypography, { variant: "button", color: "secondary", fontWeight: "bold", sx: { textTransform: "none" }, field: "cancelLabel" }) }) })] })) : null })] })] }));
};
export default OrganizationProfile;
